(() => {
  gsBuilderBanner = {
    state: {
      bannerUrlSmall: "https://cdn.shopify.com/s/files/1/0635/8614/0214/files/Small_49b425d8-a945-402b-99e3-d5724168e4fb.png?v=1742532077", /*** SMALL IMAGE URL HERE ***/
      bannerUrlLarge: "https://cdn.shopify.com/s/files/1/0635/8614/0214/files/Large.png?v=1742234062", /*** LARGE IMAGE URL HERE ***/
      bannerAlt: "banner"  /*** ALT TEXT HERE ***/
    },
    init: function () {
      if (!this.state.bannerUrlSmall || !this.state.bannerUrlLarge) {
        console.warn("Banner URLs not set.");
        return;
      }
  
      this.events();
    },
    events: function() {
      const that = this;
      window.addEventListener("DOMContentLoaded", function(e) {
        that.handleBanner(e);
      });
      window.addEventListener("resize", function(e) {
        that.handleBanner(e);
      });
    },
    handleBanner: function(e) {
      const gsBuilderRoot = document.getElementById('boxBuilderRoot');
      const parentNode = gsBuilderRoot && gsBuilderRoot.parentNode;
  
      if (gsBuilderRoot && parentNode) {
        const existingBanner = parentNode.querySelector('.gs__box-builder-banner');
        if (existingBanner) {
          existingBanner.remove();
        }

        const bannerEl = document.createElement('img');
        bannerEl.src = window.innerWidth <= 768 ? this.state.bannerUrlSmall : this.state.bannerUrlLarge;
        bannerEl.setAttribute('alt', this.state.bannerAlt);
  
        const wrapperEl = document.createElement('div');
        wrapperEl.className = "gs__box-builder-banner";
        wrapperEl.appendChild(bannerEl);
  
        parentNode.insertBefore(wrapperEl, gsBuilderRoot);
      }
    }
  };
  gsBuilderBanner.init();
})();
